export const CONFIG_CHANGED = "config_changed";
export const CONFIG_HELP_BUTTON_CLICKED = "config_help_button_clicked";
export const ON_SAVE_CONFIGS_SUCCESSFUL = "on_save_configs_successful";
export const ON_SAVE_CONFIGS_FAILED = "on_save_configs_failed";